import { render, staticRenderFns } from "./CommonStoreList.vue?vue&type=template&id=408ad23c&scoped=true"
import script from "./CommonStoreList.vue?vue&type=script&lang=js"
export * from "./CommonStoreList.vue?vue&type=script&lang=js"
import style0 from "./CommonStoreList.vue?vue&type=style&index=0&id=408ad23c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408ad23c",
  null
  
)

export default component.exports